import { useState, useEffect } from "react";
import { trackEvent, trackSelect } from "../../lib/utils/analytics";
import { IconQuestionCircle } from "../icons/IconQuestionCircle";
import usePersistentStore from "../../lib/store/PersistentStore";
import { shallow } from "zustand/shallow";
import useGameStore from "../../lib/store/GameStore";

function HowToPlayButton({ modalTitle }) {
  const [saveInstructionsDismissed, history, guessesLeft] = usePersistentStore(
    (state) => [
      state.saveInstructionsDismissed,
      state.history,
      state.guessesLeft,
    ],
    shallow
  );

  const [setIsOpen] = useGameStore((state) => [state.setIsHelpOpen]);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const show = Object.keys(history).length > 1 || guessesLeft == 0;

  function closeModal() {
    saveInstructionsDismissed(true);
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
    trackEvent("how_to_play_button");
    trackSelect({
      contentType: "button",
      itemId: "how_to_play",
    });
  }

  return (
    <>
      {false && isClient && !show ? (
        <button
          aria-label={modalTitle}
          onClick={openModal}
          className="-my-0.5 inline-flex cursor-pointer items-center  rounded-full border border-gray-200 px-4 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-300 md:border-2 md:text-sm"
        >
          {/* How to Play */}
          <IconQuestionCircle className="ml-2 h-5 w-5 md:ml-3 md:h-6 md:w-6" />
        </button>
      ) : (
        <button
          aria-label={modalTitle}
          onClick={openModal}
          className="-my-2 flex w-10 items-center justify-center py-2 text-xs font-bold uppercase text-black md:w-auto md:px-2 md:text-sm"
        >
          <IconQuestionCircle className="h-6 w-6 sm:h-7 sm:w-7" />
        </button>
      )}
    </>
  );
}

export default HowToPlayButton;
